export function appendCartItems() {
  if (document.querySelector('cart-items')) return;

  // Add cart items tag when the cart drawer section is missing so we can still run the JS associated with the error handling
  const cartItems = document.createElement('cart-items');
  document.body.appendChild(cartItems);
}

export function floatLabels(container) {
  container.querySelectorAll('.form-field').forEach((element) => {
    const label = element.querySelector('label');
    const input = element.querySelector('input, textarea');
    if (label && input) {
      input.addEventListener('keyup', (event) => {
        if (event.target.value !== '') {
          label.classList.add('label--float');
        } else {
          label.classList.remove('label--float');
        }
      });
      if (input.value && input.value.length) {
        label.classList.add('label--float');
      }
    }
  });
}
